import { render, staticRenderFns } from "./TheIDTEditForm.vue?vue&type=template&id=c2c4bf4a&"
import script from "./TheIDTEditForm.vue?vue&type=script&lang=js&"
export * from "./TheIDTEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports